/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Dont_Have_AccountInputs */



/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Login_Dont_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_dont_have_account = /** @type {((inputs?: Login_Dont_Have_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Dont_Have_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n'avez pas de compte ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben noch kein Konto?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non hai un account?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("У вас нет аккаунта?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿No tienes una cuenta?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("还没有账号？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アカウントをお持ちではありませんか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आपके पास खाता नहीं है?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não tem uma conta?")
	return /** @type {LocalizedString} */ ("Don't have an account?")
});